import script from "./MapElemInfoNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoNew.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoNew.vue?vue&type=style&index=0&id=242bb363&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242bb363"]])

export default __exports__